import i18next from 'i18next';
import toast from 'react-hot-toast';
import { PiWarningCircleFill } from 'react-icons/pi';

export const warningToast = (message: string, values?: Record<any, string>) =>
  toast.success(i18next.t(message, values), {
    icon: <PiWarningCircleFill color='orange' size={40} />,
    duration: Infinity,
  });
